import { getEntityTemplateLang } from '~services/entity-definitions/helpers';
import { createTemporaryEntityId } from '~services/entity-definitions/template-helpers';

export default () => ({
  data: {
    type: 'paragraph--color',
    id: createTemporaryEntityId(),
    attributes: {
      langcode: getEntityTemplateLang(),
      status: true,
      default_langcode: true,
      field_cmyk: null,
      field_hex: '#999999',
      field_light_color: null,
      field_ncs: null,
      field_pantone: null,
      field_ral: null,
      field_rgb: null,
      field_scss_less: null,
      field_search_text: null,
      field_title: { value: 'I am a Color', format: 'rich_text' },
    },
    relationships: {
      field_tags: {
        data: [],
      },
    },
    links: {},
    permissions: {
      update: true,
      create: true,
      delete: true,
    },
  },
  included: [],
});
